var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stepper',{staticClass:"redeem-stepper",attrs:{"currentStep":_vm.currentStep,"steps":[{ name: 'conta' }, { name: 'cliente SKY' }, { name: 'feito!' }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }